export enum QuestionType {
  termFirst,
  definitionFirst,
  pronFirst,
  random,
  showAll,
}
